module.exports = __webpack_public_path__ + "static/media/icon-bath.545951dc.svg";